/* eslint-disable */
import styled from 'styled-components';
import { Link } from 'gatsby';

import * as text from 'src/components/general/TextStyles';
import { BorderLink } from '../general';

export const Title = styled.h2`
  ${text.FS42}
  margin-bottom: 25px;
  max-width: 1000px;
  text-align: center;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-bottom: 15px;
  }
`;

interface IText {
  weight?: string;
  color?: string;
}

export const Text = styled.p<IText>`
  ${text.FS17}
  ${(props: IText) => props.weight && `font-weight: ${props.weight};`}
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.secondaryBlack};
`;

export const LaunchSection = styled.section`
  width: 100vw;
  background: linear-gradient(
    180deg,
    rgba(196, 224, 254, 0) 0%,
    rgba(196, 224, 254, 0.5) 10%,
    rgba(196, 224, 254, 0) 70%
  );
`;

export const LaunchSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 95px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: 50px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-top: 35px;
  }
`;

export const LaunchSectionUpperBox = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  column-gap: 60px;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    column-gap: 60px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    flex-direction: column-reverse;
    align-items: center;
    row-gap: 35px;
  }
`;

export const LaunchSectionUpperLeftBox = styled.div`
  max-width: 620px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    align-self: flex-start;
  }
`;

export const LaunchSectionUpperLeftButtonBox = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
  margin-top: 40px;

  & a,
  button {
    height: 56px;
    border-radius: 16px;
    padding: 0 35px;
    font-size: 17px;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
      height: 50px;
      padding: 0 20px;
      font-size: 15px;
      width: 100%;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.xs}px) {
      & > span {
        text-align: center;
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: 32px;
    column-gap: 26px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    column-gap: 15px;
    margin-top: 25px;
    justify-content: center;
  }
`;

export const LaunchSectionUpperRightBox = styled.div`
  margin-right: 185px;
  margin-bottom: -20px;

  @media (max-width: ${(props) => props.theme.breakpoints.xxl}px) {
    margin-right: 50px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-right: -5px;
    margin-bottom: -85px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-right: 0px;
    margin-bottom: 0px;
    margin-top: 320px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    margin-top: 265px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 185px;
  }
`;

export const LaunchSectionUpperRightImageBox = styled.div`
  position: absolute;
  bottom: -10px;
  left: -86px;

  & > img {
    width: 542px;
    aspect-ratio: 1/0.75;

    @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
      width: 460px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
      width: 325px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.xs}px) {
      width: calc(100vw - 40px);
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    left: -90px;
    bottom: -10px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    left: -40px;
    bottom: 0px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    left: 50%;
    transform: translateX(-50%);
    top: -190px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xs}px) {
    left: 50%;
    transform: translateX(-50%);
    top: -200px;
  }
  @media (max-width: 360px) {
    top: auto;
    bottom: 35%;
  }
  @media (max-width: 300px) {
    bottom: 55%;
  }
`;

export const LaunchLowerBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LaunchIconRowBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 29px;
  margin-top: 130px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: 150px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const LauchTitle = styled.h1`
  font-size: 64px;
  line-height: 120%;
  font-weight: ${(props) => props.theme.weights.extraBold};

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    font-size: 50px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    font-size: 32px;
  }
`;

export const LaunchDescription = styled.p`
  ${text.FS17}
  margin-top: 25px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 15px;
  }
`;

export const LaunchGradientBox = styled.div`
  ${text.FS16}
  line-height: 150%;
  background: linear-gradient(90deg, #dfe9f3 0%, #ffffff 100%);
  border-radius: 4px 16px 16px 16px;
  color: #a4a3ad;
  padding: 15px;
  width: 416px;
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding: 10px;
    font-size: 14px;
    width: 100%;
    max-width: 416px;
  }

  & > a {
    font-weight: ${(props) => props.theme.weights.bold};
  }
`;

export const LaunchIconBox = styled.div<{ $active?: boolean }>`
  width: 56px;
  height: 56px;
  border: 1px solid ${(props) => props.theme.colors.borderColor};
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: ${(props) => props.theme.transition.primary};
  transform: ${(props) => `scale(${props.$active ? '1.4' : '1'})`};

  &:hover {
    transform: scale(1.4);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    transition: none;
    height: 80px;
    width: 80px;
    position: relative;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 24px;

    &:hover {
      transform: translateX(-50%);
    }
    & svg {
      width: 40px;
      height: 40px;
    }
  }
`;

export const LaunchDesktopRowBox = styled.div`
  margin-top: 42px;
  position: relative;
  width: 100%;
  max-width: 1105px;
  height: 365px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const LaunchDesktopProductsCardBox = styled.div<{ $active?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: ${(props) => (props.$active ? '1' : '0')};
  pointer-events: ${(props) => (props.$active ? 'all' : 'none')};
  & * {
    pointer-events: ${(props) => (props.$active ? 'all' : 'none')};
  }
`;

export const LaunchMobileProductsCarouselWrapper = styled.div`
  display: none;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-top: 70px;
    display: block;
  }
`;

export const LaunchMobileProductsCarouselBox = styled.div`
  position: relative;
  overflow: visible;
  max-width: 100vw;
`;

export const LaunchMobileProductsCarousel = styled.div`
  overflow-x: auto;
  display: flex;
  -webkit-overflow-scrolling: touch;
  -ms-scroll-snap-type: x mandatory;
  scroll-snap-type: x mandatory;

  pointer-events: auto;
  padding: 18px 60px 40px;
  margin: 0 -24px;

  & > div {
    display: flex;
    justify-content: center;
  }

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const LaunchProductCardBox = styled.div`
  background: linear-gradient(90deg, #e6e9f0 0%, #eef1f5 100%);
  border-radius: 48px;
  width: 100%;
  max-width: 1105px;
  min-height: 365px;
  padding: 20px 20px 20px 50px;
  display: flex;
  justify-content: space-between;
  column-gap: 60px;
  margin: 0 auto;
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin: 0;
    padding: 0px 40px 20px;
    width: calc(100vw - 80px);
    display: block;
    scroll-snap-align: center;
    position: static;

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: calc(100vw - 75px);
    padding: 0px 20px 40px;
  }
`;

export const LaunchProductCardDotsRow = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LaunchProductCardDotBox = styled.div`
  padding: 4px;
`;

export const LaunchProductCardDot = styled.div<{ $active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  padding: 4px;
  background: ${(props) =>
    props.$active ? props.theme.colors.blue : props.theme.colors.borderColor};
`;

export const LaunchProductCardTextBox = styled.div`
  max-width: 500px;
  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    max-width: calc(100% - 470px);
    position: relative;
    z-index: 1;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    max-width: none;
    margin-top: -8px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    display: flex;
    flex-direction: column;
    align-items: center;

    & > div:first-child {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
`;

export const LaunchProductCardDescription = styled.p`
  ${text.FS17}
  line-height: 34px;
  color: #6e7178;
  font-weight: ${(props) => props.theme.weights.bold};

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    font-size: 13px;
  }
`;

export const LaunchProductCardTitle = styled.h2`
  ${text.FS27}
  margin-top: 15px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 0px;
  }
`;

export const LaunchProductCardList = styled.ul`
  margin-top: 20px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 25px;
  }
`;

export const LaunchProductCardListItem = styled.li`
  list-style: disc;
  margin-left: 14px;
  ${text.FS17}
  color: ${(props) => props.theme.colors.secondaryBlack};

  &:not(:last-child) {
    margin-bottom: 7px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    line-height: 130%;

    &:not(:last-child) {
      margin-bottom: 13px;
    }
  }
`;

export const LaunchProductCardImageBox = styled.div`
  height: 100%;
  position: absolute;
  right: 0px;
  top: 0px;
  border-radius: 0px 48px 48px 0px;
  overflow: hidden;

  & img {
    object-fit: cover;
    object-position: left;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    z-index: 0;
    /* -webkit-mask-image: -webkit-linear-gradient(
      180deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 50%,
      rgba(0, 0, 0, 0)
    ); */
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const LaunchProductCardLearnButtonBox = styled.div`
  margin-top: 20px;
  & a {
    width: fit-content;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
      width: 190px;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 30px;
  }
`;

export const HardestSection = styled.section`
  margin-top: 105px;
  width: 100vw;
  background-color: ${(props) => props.theme.colors.secondaryBlack};
  padding-top: 110px;
  z-index: 0;
  background: linear-gradient(
    180deg,
    rgba(33, 33, 51, 1) 0%,
    rgba(62, 63, 80, 1) 55%,
    rgba(33, 33, 51, 1) 100%
  );

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    padding-top: 100px;
    margin-top: 100px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding-top: 70px;
    margin-top: 70px;
  }
`;

export const HardestBottomRound = styled.div`
  width: 100%;

  & > div {
    scroll-margin-top: 60px;
    position: relative;
    bottom: 0px;

    & svg {
      width: 100%;
      height: auto;
      display: block;
    }

    &::after {
      content: '';
      position: absolute;
      top: calc(100% - 0px);
      right: 0;
      bottom: -0px;
      left: 0;
      background-color: ${(props) => props.theme.colors.white};
    }
  }
`;

export const HardestContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const HardestTitle = styled.h2`
  ${text.FS42}
  margin-bottom: 25px;
  max-width: 1000px;
  text-align: center;
  color: ${(props) => props.theme.colors.white};

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    font-size: 28px;
  }
`;

export const HardestTitleRowBox = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  margin-top: 25px;

  @media (max-width: ${(props) => props.theme.breakpoints.xxl}px) {
    column-gap: 10px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    max-width: 100vw;
    padding: 0 28px;
    overflow-x: scroll;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    padding: 0 20px;
  }
`;

export const HedestCardTitle = styled.button<{ $active: boolean }>`
  ${text.FS17}
  background-color: ${(props) =>
    props.$active ? props.theme.colors.white : 'transparent'};
  color: ${(props) =>
    props.$active
      ? props.theme.colors.secondaryBlack
      : props.theme.colors.offWhite1};
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  transition: ${(props) => props.theme.transition.primary};
  white-space: nowrap;

  &:hover {
    background-color: ${(props) =>
      props.$active ? props.theme.colors.white : '#353547'};
  }

  @media (min-width: 3253px) {
    background-color: transparent;
    color: ${(props) => props.theme.colors.offWhite1};
    &:hover {
      background-color: transparent;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xxl}px) {
    padding: 10px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    &:hover {
      background-color: ${(props) =>
        props.$active ? props.theme.colors.white : 'transparent'};
    }
  }
`;

export const HardestRowBox = styled.div`
  display: flex;
  column-gap: 50px;
  overflow-x: scroll;
  overflow-y: hidden;
  width: 100vw;
  padding: 90px 120px 180px 120px;

  @media (min-width: 1600px) {
    padding: 90px 120px 180px calc(50vw - 650px);
  }
  @media (min-width: 3253px) {
    padding: 90px 120px 180px 120px;
  }
  @media (min-width: 5075px) {
    justify-content: center;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    padding: 70px 50px 130px 40px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: 60px 50px 130px 40px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    padding: 60px 40px 130px 25px;
    column-gap: 20px;
  }

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HardestCardSecondaryImageBox = styled.div<{
  left?: number;
  right?: number;
  top: number;
  width?: number;
}>`
  position: absolute;
  top: ${(props) => `${props.top}%`};
  left: ${(props) => props.left && `${props.left}%`};
  right: ${(props) => props.right && `${props.right}%`};
  width: ${(props) => `${props.width}%`};
  z-index: 1;
`;

export const HardestCardBox = styled.div<{ index: number }>`
  width: 560px;
  display: flex;
  flex-direction: ${(props) =>
    props.index % 2 === 0 ? 'column' : 'column-reverse'};
  align-items: ${(props) =>
    props.index % 2 === 0 ? 'flex-start' : 'flex-end'};
  position: relative;
  row-gap: 15px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    width: 450px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 310px;
    row-gap: 10px;
  }
  &:last-child {
    & > div {
      ${HardestCardSecondaryImageBox} {
        width: 230px;
        right: -45px;

        @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
          width: 184px;
          right: -35px;
        }
        @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
          width: 127px;
          right: -25px;
        }
      }
    }
  }
`;

export const HardestCardImageBox = styled.div<{ secondary?: any }>`
  width: inherit;
  box-shadow: 0px 35px 50px -10px rgba(8, 10, 32, 0.15);
  border-radius: 8px;
  position: relative;

  & > img {
    object-fit: cover;
  }
`;

export const HardestCardDescription = styled.p`
  ${text.FS15}
  color: #ADADBF;
  display: flex;
  align-items: center;
`;

export const DiscoverSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 75px;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: 50px;
  }
`;

export const DiscoverUnderTitle = styled.div`
  display: flex;
  column-gap: 15px;
  align-items: center;
  margin-top: -10px;
  margin-right: -60px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    column-gap: 20px;
    margin-right: -50px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-right: 0px;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 30px;
    margin-top: 0px;
  }
`;

export const DiscoverRow = styled.div`
  margin-top: 70px;
  display: flex;
  column-gap: 20px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    width: 100%;
    justify-content: center;
    margin-top: 55px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    flex-wrap: wrap;
    row-gap: 70px;
  }
`;

export const DiscoverFullCardBox = styled.div`
  width: 33.33%;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    width: 50%;
    max-width: 442px;
    &:last-child {
      display: none;
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    min-width: 350px;
    &:last-child {
      display: block;
    }
  }
`;

export const DiscoverCardBox = styled.div<{ index: number }>`
  width: 100%;
  height: 535px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  border-radius: 32px;
  ${(props) => {
    switch (props.index) {
      case 0:
        return 'background-color: #28BDF5;';
      case 1:
        return 'background-color: #FDBFC0;';
      case 2:
        return 'background-color: #13AE4B;';
    }
  }}
`;

export const DiscoverImageBox = styled.div`
  height: 400px;
  width: 185px;

  & > img {
    border-radius: 16px;
    border: 3px solid ${(props) => props.theme.colors.black};
  }
`;

export const DiscoverCardUnderBox = styled(Link)`
  display: flex;
  column-gap: 17px;
  border-radius: 16px;
  margin-top: 30px;
  transform: translateY(0px);
  transition: ${(props) => props.theme.transition.primary};

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    &:hover {
      transform: translateY(0px);
    }
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    column-gap: 10px;
  }
`;

export const DiscoverIconBox = styled.div<{ index: number }>`
  height: 50px;
  width: 50px;
  min-width: 50px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => {
    switch (props.index) {
      case 0:
        return 'background-color: #28BDF5;';
      case 1:
        return 'background-color: #FDBFC0;';
      case 2:
        return 'background-color: #13AE4B;';
    }
  }}
`;

export const TableSection = styled.section`
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: 100px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    display: none;
  }
`;

export const TableBox = styled.div`
  margin-top: 70px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin: 70px -15px 0;
  }
`;

export const BlueSection = styled.section`
  width: 100vw;
  background: linear-gradient(
    180deg,
    rgba(115, 123, 248, 0) 0%,
    rgba(115, 123, 248, 0.15) 40%,
    rgba(115, 123, 248, 0) 80%
  );
  padding-top: 110px;
  padding-bottom: 150px;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    padding-top: 100px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    background: ${(props) => props.theme.colors.blue};
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top: 100px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 70px;
  }
`;

export const BlueBox = styled.div`
  background-color: ${(props) => props.theme.colors.blue};
  padding: 70px;
  color: ${(props) => props.theme.colors.white};
  border-radius: 31.5px;
  z-index: 0;
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    padding: 70px 40px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    padding: 70px 20px 100px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    padding: 70px 0px 100px;
  }
`;

export const BlueBoxContent = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
  z-index: 2;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const BlueTextBox = styled.div`
  width: calc(406 / 1440 * 100vw);

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    width: calc(406 / 1024 * 100vw);
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: auto;
  }
`;

export const BlueBlurEllipse = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  width: 1105px;
  height: 462px;
  position: absolute;
  pointer-events: none;
  left: calc(263 / 1330 * 100%);
  top: calc(100 / 1330 * 100%);
  border-radius: 50%;
  transform: rotate(-23.71deg);
  filter: blur(150px);
  opacity: 0.4;
  z-index: 1;

  @media (max-width: ${(props) => props.theme.breakpoints.md}px) {
    left: calc(150 / 1330 * 100%);
  }
`;

export const BlueTitle = styled.h2`
  ${text.FS42}
  margin-bottom: 20px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    text-align: center;
  }
`;

export const BlueDescription = styled.p`
  ${text.FS17}
  color: ${(props) => props.theme.colors.offWhite};
  margin-bottom: 2px;
  margin-right: 14px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-right: 20px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    text-align: center;
    margin-bottom: 15px;
  }
`;

export const BlueLink = styled(BorderLink)`
  ${text.FS17}
  &::before {
    bottom: -1.5px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    &::before {
      bottom: 0px;
    }
  }
`;

export const BlueGrid = styled.div`
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  flex-wrap: wrap;
  width: calc((650 / 1440 * 100vw) + 20px);

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    width: calc((420 / 1024 * 100vw) + 20px);
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-top: 50px;
    width: auto;
    justify-content: center;
  }
`;

export const GridItem = styled.div`
  width: 325px;
  height: 80px;
  background-color: ${(props) => `${props.theme.colors.white}cc`};
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  color: ${(props) => props.theme.colors.secondaryBlack};

  @media (max-width: ${(props) => props.theme.breakpoints.xxl}px) {
    width: calc(325 / 1440 * 100vw);
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    width: calc(200 / 1024 * 100vw);
  }
  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    width: 325px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.xs}px) {
    width: 100%;
    max-width: 325px;
  }
`;

export const GridIconBox = styled.div`
  margin-bottom: 24px;
  width: 64px;
`;

export const GridTitle = styled.h3`
  ${text.FS17}
  font-weight: ${(props) => props.theme.weights.bold};

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    font-size: 17px;
  }
`;

export const FAQSection = styled.section`
  position: relative;
  z-index: 2;
  background-color: ${(props) => props.theme.colors.white};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-top: 100px;
    margin-bottom: 0px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 70px;
  }
`;

export const FAQBox = styled.div`
  margin-top: 5px;
  max-width: 1105px;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-top: 20px;
  }
`;

export const StickyButtonBox = styled.div`
  margin-top: 80px;

  @media (max-width: ${(props) => props.theme.breakpoints.xl}px) {
    margin-top: 70px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
    width: 100%;
  }
  /* margin: 90vh auto 25px;
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  bottom: 25px;
  z-index: 10;
  max-width: 280px; */

  & a,
  button {
    height: 56px;
    border-radius: 16px;
    padding: 0 35px;
    font-size: 17px;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}px) {
      height: 50px;
      width: 100%;
      font-size: 15px;
    }
  }
`;
